import { Grid, Typography, TypographyProps } from "@mui/material";

type Props = {
  errorMessage?: string;
  helperText?: string;
  TypographyProps?: TypographyProps;
};

const InputHelperText = ({
  errorMessage,
  helperText,
  TypographyProps = {},
}: Props) => {
  if (!errorMessage && !helperText) return null;

  return (
    <Grid item xs={12}>
      <Typography
        mt="3px"
        ml="14px"
        color={errorMessage ? "error" : "textSecondary"}
        fontSize="12px"
        letterSpacing="0.03333em"
        {...TypographyProps}
      >
        {errorMessage || helperText}
      </Typography>
    </Grid>
  );
};

export default InputHelperText;
